export const getViewOnlyFieldsPOItems = (allFieldsDisabled: boolean) => {
  if (allFieldsDisabled) {
    return ['qty', 'rate', 'sku', 'billedQty', 'notes', 'receivedQty', 'items', 'subLines']
  }
  return []
}
